
export class DatabaseForgeinKey {
    tableName: string;
    columnName: string;
}